module.exports = __webpack_public_path__ + "img/avatar_real_4.40437738.jpg";